"use client";

import { NextPage } from "next";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import { useState } from "react";
import { validateEmail } from "@/lib/utils";
import { toast } from "sonner";
import { resetPassword } from "@/app/actions/auth";
interface Props {}

const ResetPasswordForm: NextPage<Props> = () => {
  const [email, setEmail] = useState<string>("");

  const sendEmail = async () => {
    if (validateEmail(email)) {
      toast.promise(resetPassword(email), {
        loading: "Sending email",
        error: "Invalid email or something went wrong, please try again",
        success: "Email has been sent!",
      });
      setEmail("");
    } else {
      toast.error("Enter a valid email address");
    }
  };

  return (
    <div>
      <div className="m-auto p-8 border border-zinc-100 rounded-lg w-[100%] lg:w-[40%]">
        <h6 className={`text-xl font-bold`}>Reset Password</h6>
        <p className="text-sm text-zinc-500">
          Enter your email - a recovery email will be sent to your email
          address.
        </p>
        <Input
          className="mt-4"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <Button className="mt-2" size="sm" onClick={sendEmail}>
          Send Email
        </Button>
      </div>
    </div>
  );
};

export default ResetPasswordForm;
